/* Copyright (c) 2020-present CloudIO Inc */

import { Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { CSSProperties } from 'react';
import SVG from 'react-inlinesvg';
import start from './start.svg';
import error from './error.svg';
import congrads from './congrads.svg';

export const StartSVG = start;
export const ErrorSVG = error;
export const NoDataFoundSVG = error;
export const CongradsSVG = congrads;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    minHeight: '260px',
    overflow: 'hidden',
    color: theme.palette.text.secondary,
    padding: 20,
  },
}));

export default function NoDataFound({
  msg,
  color,
  svgSrc,
  style,
}: {
  svgSrc?: string;
  msg: React.ReactNode;
  color?: 'error';
  style?: CSSProperties;
}) {
  const classes = useStyles();

  if (process.env.NODE_ENV === 'test') {
    return <>No data found!</>;
  }

  return (
    <div className={classes.root} style={style}>
      {color === 'error' ? (
        <SVG width={200} height={200} src={svgSrc ?? error} />
      ) : (
        <SVG width={200} height={200} src={svgSrc ?? start} />
      )}
      {typeof msg === 'string' ? (
        <Typography
          color={color}
          variant="subtitle2"
          sx={{ maxWidth: 400, whiteSpace: 'pre-wrap', textAlign: 'center' }}
        >
          {msg}
        </Typography>
      ) : (
        msg
      )}
    </div>
  );
}

export function SimpleNoDataFound({ msg }: { msg: React.ReactNode }) {
  return <NoDataFound svgSrc={NoDataFoundSVG} msg={msg} />;
}
